const features = [
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Advanced Security',
    description:
      'End-to-end encryption and zero-knowledge architecture ensure your data stays private. We never store, sell, or share your personal information.',
    color: 'bg-teal-50',
    iconColor: 'text-teal-600',
    iconBg: 'bg-teal-100',
    size: 'large',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Blazing Performance',
    description:
      'Optimized for the latest iOS hardware, our apps run smoothly without draining your battery or slowing down your device.',
    color: 'bg-rose-50',
    iconColor: 'text-rose-500',
    iconBg: 'bg-rose-100',
    size: 'small',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Intuitive Design',
    description:
      'Clean, native iOS interfaces that feel familiar from the first tap. No learning curve — just open and use.',
    color: 'bg-amber-50',
    iconColor: 'text-amber-600',
    iconBg: 'bg-amber-100',
    size: 'small',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Regular Updates',
    description:
      'We continuously improve our apps with new features, security patches, and iOS compatibility updates.',
    color: 'bg-violet-50',
    iconColor: 'text-violet-600',
    iconBg: 'bg-violet-100',
    size: 'small',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Support',
    description:
      'Our expert support team is available to help you get the most out of every product we build.',
    color: 'bg-sky-50',
    iconColor: 'text-sky-600',
    iconBg: 'bg-sky-100',
    size: 'small',
  },
];

export default function FeaturesSection() {
  const [large, ...rest] = features;

  return (
    <section id="features" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="text-teal-500 text-xs font-semibold tracking-widest uppercase">Why Choose Us</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Why Choose{' '}
            <span className="text-teal-500">DUMAG DOO</span>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Large Feature */}
          <div className={`lg:row-span-2 rounded-3xl p-10 flex flex-col justify-between ${large.color} min-h-[420px]`}>
            <div>
              <div className={`w-16 h-16 flex items-center justify-center rounded-2xl ${large.iconBg} mb-8`}>
                <i className={`${large.icon} text-3xl ${large.iconColor}`} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{large.title}</h3>
              <p className="text-gray-600 leading-relaxed">{large.description}</p>
            </div>
            <div className="mt-10">
              <img
                src="https://public.readdy.ai/ai/img_res/2a17caefa07e08feffa393d52711eed7.jpg"
                alt="Security feature"
                className="w-full h-40 object-cover object-top rounded-2xl"
              />
            </div>
          </div>

          {/* Small Features */}
          {rest.map((feature) => (
            <div
              key={feature.title}
              className={`rounded-3xl p-8 flex flex-col gap-4 ${feature.color}`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${feature.iconBg}`}>
                <i className={`${feature.icon} text-2xl ${feature.iconColor}`} />
              </div>
              <h3 className="text-xl font-bold text-gray-900">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
